import firebase from 'firebase/app';
// import 'firebase/firestore'
import 'firebase/database';
import 'firebase/auth';
import 'firebase/messaging';
import 'firebase/storage';
import 'firebase/firestore';

var config = {
    apiKey: "AIzaSyBagPqmtw8XxYvKdcqwykijiFYcdALqxVs",
    authDomain: "maximum-controls-app.firebaseapp.com",
    databaseURL: "https://maximum-controls-app.firebaseio.com",
    projectId: "maximum-controls-app",
    storageBucket: "maximum-controls-app.appspot.com",
    messagingSenderId: "293590155250",
    appId: "1:293590155250:web:5ca6968e7c6f6d186af56b",
    measurementId: "G-28LSL696Z1"
};

firebase.initializeApp(config);
// firebase.firestore().settings({ timestampsInSnapshots: true });

export default firebase;